import { cn } from '@cannect/lib/utils'
import { Skeleton, Typography } from '@cannect/new-components/atoms'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { ISubcategoryCirclesProps } from './types'

export const SubcategoryCirclesUI = ({
  subcategories,
  isLoading,
  onSubcategoryClick,
  isSelectedSubcategory,
  className
}: ISubcategoryCirclesProps) => {
  const [swiperInstance, setSwiperInstance] = useState<any>(null)

  if (isLoading) {
    return (
      <section className={cn('mb-12', className)}>
        <div className="flex gap-6 overflow-hidden">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="flex w-[104px] flex-shrink-0 flex-col items-center gap-2">
              <Skeleton className="h-20 w-20 rounded-full" />
              <Skeleton className="h-3 w-16" />
            </div>
          ))}
        </div>
      </section>
    )
  }

  return (
    <section className={cn('relative mb-12', className)}>
      <button
        type="button"
        aria-label="Categoria anterior"
        onClick={() => swiperInstance?.slidePrev()}
        className="absolute left-0 top-10 z-10 flex h-8 w-8 -translate-x-1/2 items-center justify-center rounded-full border border-none bg-white text-neutral-600 shadow-sm hover:bg-neutral-50">
        <ChevronLeft size={18} />
      </button>

      <Swiper onSwiper={setSwiperInstance} slidesPerView="auto" spaceBetween={24} className="!mx-8">
        {subcategories.map((subcategory) => {
          const isSelected = isSelectedSubcategory(subcategory)

          return (
            <SwiperSlide key={subcategory.name} className="!w-[104px]">
              <button
                type="button"
                onClick={() => onSubcategoryClick(subcategory)}
                className="flex w-full flex-col items-center gap-2 bg-transparent border-none">
                <div
                  className={cn(
                    'h-20 w-20 overflow-hidden rounded-full bg-neutral-100 ring-1 ring-neutral-200 transition-all',
                    isSelected && 'ring-2 ring-primary-500'
                  )}>
                  <img src={subcategory.image} alt={subcategory.name} className="h-full w-full object-contain p-2" />
                </div>
                <Typography.Text
                  weight="semibold"
                  className="line-clamp-2 text-center text-xs leading-tight text-neutral-800">
                  {subcategory.name}
                </Typography.Text>
              </button>
            </SwiperSlide>
          )
        })}
      </Swiper>

      <button
        type="button"
        aria-label="Próxima categoria"
        onClick={() => swiperInstance?.slideNext()}
        className="absolute right-0 top-10 z-10 flex h-8 w-8 translate-x-1/2 items-center justify-center rounded-full border border-none bg-white text-neutral-600 shadow-sm hover:bg-neutral-50">
        <ChevronRight size={18} />
      </button>
    </section>
  )
}
